<div class="container">
  @if ((measureSelected$ | async)) {
    <measure-details></measure-details>
  }
  @if ((cutSelected$ | async)) {
    <cut-details></cut-details>
  }
  @if ((elevationSelected$ | async)) {
    <elevation-details></elevation-details>
  }
  @if ((markerSelected$ | async)) {
    <marker-details></marker-details>
  }
  @if ((detectionSelected$ | async)) {
    <detection-details></detection-details>
  }
  @if ((volumeSelected$ | async)) {
    <volume-details></volume-details>
  }
</div>
